import { create } from 'zustand';

type Metric = 'assigned' | 'completed' | 'canceled';

type CombinedState = {
  view: 'combined';
  metric?: never;
};

type ComparisonState = {
  view: 'comparison';
  metric: Metric;
};

type ViewState = CombinedState | ComparisonState;

// A type union is used since an interface can't extend a type union
type State = ViewState & {
  setViewState: (state: ViewState) => void;
};

/**
 * Store to persist form trends state. This is used in favor of search params
 * because we want to persist the state in memory only. This store is needed
 * because the component is unmounted when changing tabs, but once we address
 * the issue with the activity component, we can rely on internal state and
 * get rid of this.
 */
export const useFormTrendsStore = create<State>((set) => ({
  view: 'combined',
  setViewState: set,
}));
